import React,  {useState , useEffect} from "react";
import { Link   } from "react-router-dom";
import {Links} from 'routes/PathLink';

import {
  useSuperInvestorsQuery
} from '../../data/company';
import Breadcrumb  from "components/Breadcrumb";
import { useInView } from "react-intersection-observer";
import { formatPostTime, APP_URL } from "../../components/config/Common";
import { useSiteSettings } from '../../contexts/site-settings/site-settings';
//import "./screens.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

const  SuperInvestorList= () => {
    //console.log('symbol===', tag)
 const [data, setData] = useState([]);
//const [page, setPage] = useState(1);
//const [loading, setLoading] = useState(false);
//const [hasMore, setHasMore] = useState(true);

const { ref, inView } = useInView({
  threshold: 0,
});


    const { sitelogo } = useSiteSettings();
    const {
        superinvestordata,
        isLoading: loading,
         fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useSuperInvestorsQuery({
        limit:49,
    });

/*
useEffect(() => {
  fetchInvestors(1);
}, []);
*/
useEffect(() => {
  if (inView && hasNextPage && !isFetchingNextPage) {
    fetchNextPage();
  }
}, [inView, hasNextPage,isFetchingNextPage]);


/*
const fetchInvestors = async (pageNo) => {
  if (loading || !hasMore) return;

  setLoading(true);

  const res = await fetch(
    `/api/super-investors?page=${pageNo}&limit=9`
  );
  const result = await res.json();

  if (result.data.length === 0) {
    setHasMore(false);
  } else {
    setData(prev => [...prev, ...result.data]);
  }

  setLoading(false);
};
*/


const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Super Investors`,
    link:null
  }
]


    console.log("superinvestordata",superinvestordata);
    return(
        <>
         <Header />
         <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
            {!superinvestordata ? 
         <section className="bg-white shadow-md p-5"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
                        <div
                        key={i}
                        className="animate-pulse bg-white border border-gray-200 rounded-xl overflow-hidden"
                        >
                            <div className="p-4 space-y-3">
                                <div className="h-4 bg-slate-200 rounded w-3/4" />
                            </div>
                        </div>
                    ))}
                </div></section>
               
            :
            <>
                <h2 className="text-2xl ">Super Investors</h2>
                <p className="mb-5">Look into the portfolio of these Super Investors to find out their favourite stocks.</p>
                <div className="w-full">{loading ? <section className="bg-white shadow-md p-5"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {[1, 2, 3, 4, 5, 6 , 7, 8, 9].map((i) => (
                        <div
                        key={i}
                        className="animate-pulse bg-white border border-gray-200 rounded-xl overflow-hidden"
                        >
                            <div className="p-4 space-y-3">
                                <div className="h-4 bg-slate-200 rounded w-3/4" />
                            </div>
                        </div>
                    ))}
                </div></section>
                :null
                }
                </div>
                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">             
                {
                    !loading && superinvestordata?.map(val=>(
                        <div className="bg-white shadow-md border border-gray-300 hover:border-accent rounded-md overflow-hidden group transition duration-300 ease-in-out">
                           <div className="w-full flex p-2 items-center justify-center text-center">
                            <Link to={`${Links.INVESTOR}/${val?.share_holder_id}`}  >
                              {val?.sh_name}
                            </Link>
                          </div>
                       </div>
                    ))
                }

                {/* 👇 invisible trigger */}
                <div ref={ref} className="h-1"></div>
                </div>
            </>
            }

            {isFetchingNextPage && (
            <div className="text-center py-4 text-gray-500">
                Loading more investors...
            </div>
            )}
            </section>
        </div>
    <Footer />
    </>
    )

}
export default SuperInvestorList